import { queryOptions } from '@tanstack/react-query';

import { crownApi } from '@/common/api/crownQueryClient';

export const listUserApplicationsQuery = queryOptions({
  queryFn: async () => (await crownApi.UserApplications_getApplications()).data,
  queryKey: ['application'],
});
